// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getPlainText, getTimestamp
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { AGENT } from 'conversations-message-history/constants/messageUses';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SlottedMessage from '../slotted-message/SlottedMessage';
import AutomatedMessageAvatar from '../avatar/AutomatedMessageAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
const TypicalResponseTimeMessage = ({
  message,
  positionDescriptors,
  ungatedForThreadMessagesUIImprovements
}) => {
  const timestamp = getTimestamp(message);
  return /*#__PURE__*/_jsx(SlottedMessage, {
    container: {
      componentProps: {
        positionDescriptors,
        use: AGENT,
        ungatedForThreadMessagesUIImprovements
      }
    },
    avatar: {
      Component: AutomatedMessageAvatar
    },
    title: {
      Component: FormattedMessage,
      componentProps: {
        message: 'conversations-inbox-message-history.responder.automatic'
      }
    },
    timestamp: {
      componentProps: {
        timestamp
      }
    },
    body: {
      componentProps: {
        contentText: getPlainText(message)
      }
    }
  });
};
TypicalResponseTimeMessage.displayName = 'TypicalResponseTimeMessage';
TypicalResponseTimeMessage.propTypes = {
  message: RecordPropType('TypicalResponseTimeMessage').isRequired,
  positionDescriptors: PositionDescriptors.isRequired
};
export default TypicalResponseTimeMessage;